import { IconName } from '@optimus-web/icons';
import { IconVariant } from '@optimus-web/local-tokens';
import { Icon } from '../Icon';
import { SupplementaryIconElement } from './style';

export interface SupplementaryIconProps {
    value: IconName;
    variant: IconVariant;
}

const SupplementaryIcon = ({ value, variant = 'basic', ...other }: SupplementaryIconProps) => (
    <SupplementaryIconElement variant={variant} {...other}>
        <Icon size="large" value={value} />
    </SupplementaryIconElement>
);

export default SupplementaryIcon;
